export default "__VITE_ASSET__CFdmhKwv__"